// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__3fBj8","footer":"ReportModalFilter_footer__q5M4G"};